/**
 * Переменные среды, доступные на фронте.
 * Подставляются webpack'ом через DefinePlugin (dotenv-webpack).
 *
 * ВАЖНО: всё что попадает сюда — публично и видно в бандле.
 * Не класть сюда секреты.
 */

declare const process: {
  env: {
    API_BASE_URL?: string;
    APP_NAME?: string;
    NODE_ENV?: 'development' | 'production' | 'test';
  };
};

export const env = {
  API_BASE_URL: process.env.API_BASE_URL ?? 'http://localhost:8003',
  APP_NAME: process.env.APP_NAME ?? 'RiChat',
  IS_DEV: process.env.NODE_ENV === 'development',
  IS_PROD: process.env.NODE_ENV === 'production',
} as const;
